import { render, staticRenderFns } from "./AuditCriteriaDetailModal.vue?vue&type=template&id=4d637f44&"
import script from "./AuditCriteriaDetailModal.vue?vue&type=script&lang=ts&"
export * from "./AuditCriteriaDetailModal.vue?vue&type=script&lang=ts&"
import style0 from "./AuditCriteriaDetailModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AuditCriteriaDetailModal.vue?vue&type=style&index=1&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports